import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { IS_TENANT } from 'tenant/config';
import useNonPalletizedType from 'utils/hooks/useNonPalletizedType';

const palletTypeText = {
  EU_PALLET: 'Eu',
  CUSTOM_PALLET: 'Sp',
  US_PALLET: 'Us',
  MIXED_PALLET: 'Mx',
  BULK: 'Bulk',
  PARCEL: 'Parcel',
  equivalent: 'Eq',
};

const NumberOfItemsCell = ({
  numberOfItems,
  typePallets,
  loadTypes,
  numberOfItemsEquivalent,
  typeOfPalletsEquivalents,
  showEquivalents,
  stops,
}) => {
  const container = stops && stops[0] ? { ...stops.filter((s) => s.container_iso_code)[0] } : {};
  const { numberOfPallets, palletText, showSpecialEquivalents } = useNonPalletizedType(
    container,
    numberOfItems,
    loadTypes,
    typePallets
  );
  showEquivalents = showSpecialEquivalents || IS_TENANT ? showSpecialEquivalents : showEquivalents;

  return (
    <span>
      {numberOfPallets} {palletTypeText[palletText] ? palletTypeText[palletText] : palletText}
      {showEquivalents && (
        <Fragment>
          ({numberOfItemsEquivalent} {typeOfPalletsEquivalents})
        </Fragment>
      )}
    </span>
  );
};

NumberOfItemsCell.propTypes = {
  numberOfItems: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  numberOfItemsEquivalent: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  typeOfPalletsEquivalents: PropTypes.string,
  typePallets: PropTypes.string,
  showEquivalents: PropTypes.bool,
};

NumberOfItemsCell.defaultProps = {
  numberOfItemsEquivalent: '',
  typeOfPalletsEquivalents: '',
  typePallets: undefined,
  showEquivalents: false,
};

export default NumberOfItemsCell;
